<template>
  <div>
    <div style="display: flex; justify-content: flex-end; margin-bottom: 10px">
      <div class="pl-2">
        <slot name="customButton"></slot>
      </div>

      <div class="pb-8">
        <DxButton
          v-if="options.allowToRefetch"
          style="margin-left: 5px; margin-bottom: -32px; z-index: 1"
          text="Reset"
          icon="refresh"
          type="normal"
          @click="
            () => {
              this.$refs[this.dataBindingRefKey].clearAll()
              $emit('initData')
            }
          "
        />
      </div>
    </div>
    <DataBinding
      :headers="headers"
      :items="items"
      :options="options"
      :customizationPage="customizationPage"
      :showHeader="showHeader"
      :showPagination="showPagination"
      :pageSize="pageSize"
      :filter="filter"
      :search="search"
      :ref="dataBindingRefKey"
    />
  </div>
</template>

<script>
import DataBinding from './DataBindingLog'
import DxButton from 'devextreme-vue/button'
export default {
  props: {
    headers: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    },
    options: {
      type: Object,
      default: () => {
        return {}
      }
    },
    customizationPage: {
      type: String,
      default: () => ''
    },
    query: {
      type: Object,
      default: () => {}
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    showPagination: {
      type: Boolean,
      default: true
    },
    pageSize: {
      type: Number,
      default: 10
    },
    filter: {
      type: Object
    },
    search: {
      type: Array
    }
  },
  components: {
    DataBinding,
    DxButton
  },
  data() {
    return { dataBindingRefKey: 'my-data-binding' }
  },
  mounted() {},
  methods: {}
}
</script>
